import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "VI. Subjective Symptoms 自覚症状", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 space-y-1 text-darkgray-800" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Check if you are experiencing any of the following"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "次のいずれかの症状がある場合には、下記のボックスにチェックを入れてください。")
], -1)
const _hoisted_4 = { class: "space-y-3 lg:columns-2" }
const _hoisted_5 = { class: "col-span-6 mt-3 pl-7" }
const _hoisted_6 = { class: "col-span-6 mt-3 pl-7" }

import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import MedicalService from '@/classes/MedicalService';
import TextInput from '@/components/inputs/TextInput.vue';
import { computed, ref, watch, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectiveSymptoms',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
},
  setup(__props) {

const props = __props

const symptoms = MedicalService.getSymptoms()
const item = ref(props.form)
const others = ref<string>('')
const showOthers = ref<boolean>(false)

const selectedVal = computed(() => item.value?.map(a => a.symptoms));

const hasOthers = computed(() => {
    
    const index = item.value.findIndex(i => i.symptoms === "Others");
    
    return index != -1 ? item.value[index] : {};
})

const addSymptom = (symptoms: string) => {
    if(!item.value.some(e => e.symptoms === symptoms)) {
        item.value.push({ symptoms,  is_checked: true })
    } else {
        item.value.splice(item.value.findIndex(i => i.symptoms === symptoms), 1);
    }
}

const othersSymptoms = () => {
    const index = item.value.findIndex(i => i.symptoms === "Others");
    if (!props.disableInputs) {
    
        if (index != -1) {
            item.value.splice(index, 1);
        } 
        
        item.value.push({ symptoms: "Others", is_checked: true, "others_description": others.value })
    } 
}

watch(
    () => others.value,
    othersSymptoms
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(symptoms), (i) => {
        return (_openBlock(), _createBlock(CheckboxInput, {
          key: i,
          id: i.label,
          label: i.label,
          rounded: false,
          disabled: __props.disableInputs,
          "is-checked": selectedVal.value.includes(i.value),
          "text-color": "text-darkgray-800",
          onChange: ($event: any) => (addSymptom(i.value))
        }, null, 8, ["id", "label", "disabled", "is-checked", "onChange"]))
      }), 128)),
      (hasOthers.value?.is_checked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(CheckboxInput, {
              "is-checked": true,
              disabled: __props.disableInputs,
              "text-color": "text-darkgray-800",
              rounded: false,
              label: "Others /その他"
            }, null, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(TextInput, {
                modelValue: hasOthers.value.others_description,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hasOthers.value.others_description) = $event)),
                id: "test_result_others",
                type: "text",
                placeholder: "Type here",
                disabled: __props.disableInputs
              }, null, 8, ["modelValue", "disabled"])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(CheckboxInput, {
              modelValue: showOthers.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showOthers).value = $event)),
              id: "others",
              rounded: false,
              disabled: __props.disableInputs,
              "text-color": "text-darkgray-800",
              label: "Others /その他"
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("div", _hoisted_6, [
              (showOthers.value)
                ? (_openBlock(), _createBlock(TextInput, {
                    key: 0,
                    modelValue: others.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((others).value = $event)),
                    id: "test_result_others",
                    type: "text",
                    placeholder: "Type here"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ], 64))
    ])
  ]))
}
}

})